export default __webpack_public_path__ + "static/media/peptide.2a0b04e8.gif";